/**
 * Analytics stubs.
 *
 * HeyCatch's autocapture handles pageviews, clicks, and SPA route changes
 * from `analytics.init` (see /app/frontend/src/index.js) — the agents.md
 * guide is explicit: "do not hand-instrument UI events; they double-count."
 *
 * These exports remain as no-ops so existing callers keep compiling. The
 * one exception is `trackSignup`, which also fires a Google Ads conversion
 * event — that's a separate ad platform and stays.
 *
 * Business events (payments, subscription changes, etc.) belong on the
 * backend per HeyCatch's step 3, not here.
 */

const noop = () => {};

// Kept for backwards-compat, no-op.
export const trackEvent = noop;

// Auth
export const trackLogin = noop;
export const trackLogout = noop;

// Signup — keep the Google Ads conversion trigger; HeyCatch autocaptures
// the click/pageview separately.
export const trackSignup = (_tier = "basic") => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-17899438401/8ZzdCOmW4qMcEMGCj9dC",
    });
  }
};

// Practice & Quiz
export const trackPracticeStart = noop;
export const trackPracticeComplete = noop;

// Tests
export const trackTestStart = noop;
export const trackTestModuleComplete = noop;
export const trackTestComplete = noop;

// Diagnostic
export const trackDiagnosticStart = noop;
export const trackDiagnosticComplete = noop;

// Subscription
export const trackSubscriptionUpgrade = noop;
export const trackPromoCodeUsed = noop;

// Feature interactions
export const trackHintUsed = noop;
export const trackCalculatorOpened = noop;
export const trackExplanationViewed = noop;

// Support
export const trackContactFormSubmit = noop;
export const trackPricingView = noop;

// Errors
export const trackError = noop;
